import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { faqs } from '../../data/content';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-cream px-5 py-16 sm:py-20" data-id="element-102" data-mp="1223in9l0x41b">
      <div className="mx-auto max-w-3xl" data-id="element-103" data-mp="124pp15w6hdhy">
        <h2 className="text-center font-serif text-[30px] leading-tight sm:text-5xl font-extrabold text-ink" data-id="element-104" data-mp="1pro4q1ch4het">
          Frequently asked questions
        </h2>
        <div className="mt-10 divide-y divide-brand-100 rounded-3xl bg-white px-5 sm:px-8" data-id="element-105" data-mp="1utdihor2z96l">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-106" data-mp="1kzo4s8weloi8" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 py-5 text-left" data-id="element-107" data-mp="28rbs6gugihfr">
                  <span className="text-[17px] font-bold leading-snug text-ink" data-id="element-108" data-mp="2oo4i3nltgi2z">{f.q}</span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-600 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-109" data-mp="2jsyyivfvzfi2" />
                </button>
                <AnimatePresence initial={false} data-id="element-110" data-mp="37fxbvk8pm7br">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-111" data-mp="32hvqutrq3xxn">
                      <p className="pb-5 text-[16px] leading-relaxed text-muted" data-id="element-112" data-mp="1n1515blcg4q4">{f.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
        <div className="mt-10" data-id="element-113" data-mp="2br9ergkjib36">
          <CtaButton label="Get the system now" data-id="element-114" data-mp="2bskglaufd8rn" />
        </div>
      </div>
    </section>;
}